import { Injectable } from '@angular/core';
import { Workbook, Worksheet, CellFormulaValue, Cell } from 'exceljs';
import * as fs from 'file-saver';
import { HelperClassService } from './clase-utilidades.services';
import { Constanst } from '../constants/constans.component';

@Injectable({
    providedIn: 'root'
})
export class ExportExcelService {

    constructor(private helperClassService: HelperClassService) { }

    exportExcelPresupuesto(excelData: { titleReport: any; nombre: any; contratante: any; compania: any; ubicacion: any; porcIva: number, aplicaIva: string, porcOtrosImp: number, dataMateriales: any[]; dataEquipos: any[]; dataManoObras: any[]; dataPartidas: any[]; formatoEscritorio: boolean; capitulosPartida: string[]; }) {

        let fontHeader = {
            name: 'Calibri',
            bold: true,
            color: { argb: '000000' },
            size: 7
        };
        const fontData = {
            name: 'Calibri',
            color: { argb: '000000' },
            size: 7
        };
        const fontDataTitle = {
            name: 'Calibri',
            color: { argb: '000000' },
            size: 11
        };
        const headerStyle = {
            font: {
                name: 'Arial',
                size: 12,
                bold: true,
                color: { argb: '000000' }
            }
        };
        let titleStyle = {
            font: {
                name: 'Arial',
                size: 18,
                bold: true,
                color: { argb: '000000' }
            }
        };

        let allborder = {
            top: {
                style: 'thin',
                color: {
                    argb: 'FF000000',
                },
            },
            left: {
                style: 'thin',
                color: {
                    argb: 'FF000000',
                },
            },
            bottom: {
                style: 'thin',
                color: {
                    argb: 'FF000000',
                },
            },
            right: {
                style: 'thin',
                color: {
                    argb: 'FF000000',
                },
            },
        };

        // Crear el libro
        let workbook = new Workbook();
        workbook.title = excelData.titleReport;
        // Establecer el modo de cálculo en automático
        workbook.calcProperties.fullCalcOnLoad = true;

        // Definir las hojas de trabajo
        let sheetMateriales: Worksheet = workbook.addWorksheet('Materiales');
        let sheetEquipos: Worksheet = workbook.addWorksheet('Equipos');
        let sheetManObras: Worksheet = workbook.addWorksheet('Mano de Obra');

        // **Hoja Materiales:**
        // Ocultar la columna A
        sheetMateriales.getColumn('A').hidden = true;
        // Titulo de Cabecera
        sheetMateriales.mergeCells('B1', 'H1');
        let titleRow = sheetMateriales.getCell('B1');
        titleRow.value = 'MATERIALES';
        titleRow.style = titleStyle;
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };

        //Fila en blanco 
        sheetMateriales.addRow([]);

        // Columnas de Materiales
        let headersMateriales: string[] = ['', 'Referencia', 'Descripción', 'Unidad', 'Precio Bs.', 'Desperdicio', 'Familias BCV', 'Proveedor'];
        //Agregar columnas a la hoja materiales
        let headerRow = sheetMateriales.addRow(headersMateriales);
        headerRow.eachCell((cell, number) => {
            cell.font = fontHeader;
        });

        // Ajustar el ancho de la columnas a una cantidad de caracteres.
        sheetMateriales.getColumn('B').width = 8.00;
        sheetMateriales.getColumn('C').width = 43.00;
        sheetMateriales.getColumn('D').width = 6.00;
        sheetMateriales.getColumn('E').width = 13.00;
        sheetMateriales.getColumn('F').width = 10.00;
        sheetMateriales.getColumn('G').width = 23.00;
        sheetMateriales.getColumn('H').width = 23.00;

        //Agregar data a la hoja materiales
        excelData.dataMateriales.forEach((d: any) => {
            let dataMaterial = sheetMateriales.addRow(Object.values(d));
            dataMaterial.font = fontData;
        });

        // set style for each cell
        sheetMateriales.eachRow(function (Row, rowNum) {
            if (rowNum > 1) { Row.height = 20; }
            Row.eachCell(function (Cell, cellNum) {
                if (rowNum == 2 || rowNum == 3) {
                    Cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    }
                } else {
                    if (cellNum == 2 || cellNum == 4) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }
                    } else if (cellNum == 5 || cellNum == 6) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'right'
                        },
                            Cell.style = {
                                numFmt: '#,##0.00',
                                font: {
                                    name: 'Calibri',
                                    color: { argb: '000000' },
                                    size: 7
                                }
                            }
                    } else {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'left',
                            wrapText: true
                        }
                    }
                }
                if (rowNum > 1) {
                    // Aplicar un borde a la celda
                    Cell.border = {
                        top: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                    };
                }

            });
        });// **Fin Hoja Materiales:**

        // **Hoja Equipos:**
        // Ocultar la columna A
        sheetEquipos.getColumn('A').hidden = true;
        // Titulo de Cabecera
        sheetEquipos.mergeCells('B1', 'F1');
        titleRow = sheetEquipos.getCell('B1');
        titleRow.value = 'EQUIPOS';
        titleRow.style = titleStyle;
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
        //Fila en blanco 
        sheetEquipos.addRow([]);

        // Columnas de Materiales
        let headersEquipos: string[] = ['', 'Referencia', 'Descripción', 'Precio Bs.', 'COP/Dep', 'Proveedor'];
        //Agregar columnas a la hoja materiales
        headerRow = sheetEquipos.addRow(headersEquipos);
        headerRow.eachCell((cell, number) => {
            cell.font = fontHeader;
        });
        // Ajustar el ancho de la columnas a una cantidad de caracteres.
        sheetEquipos.getColumn('B').width = 8.00;
        sheetEquipos.getColumn('C').width = 43.00;
        sheetEquipos.getColumn('D').width = 13.00;
        sheetEquipos.getColumn('E').width = 8.00;
        sheetEquipos.getColumn('F').width = 23.00;

        //Agregar data a la hoja equipos
        excelData.dataEquipos.forEach((d: any) => {
            let dataEquipo = sheetEquipos.addRow(Object.values(d));
            dataEquipo.font = fontData;
        });
        // set style for each cell
        sheetEquipos.eachRow(function (Row, rowNum) {
            if (rowNum > 1) { Row.height = 20; }
            Row.eachCell(function (Cell, cellNum) {
                if (rowNum == 2 || rowNum == 3) {
                    Cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    }
                } else {
                    if (cellNum == 2) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }
                    } else if (cellNum == 4) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'right'
                        },
                            Cell.style = {
                                numFmt: '#,##0.00',
                                font: {
                                    name: 'Calibri',
                                    color: { argb: '000000' },
                                    size: 7
                                }
                            }
                    } else if (cellNum == 5) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'right'
                        },
                            Cell.style = {
                                numFmt: '#,##0.000000',
                                font: {
                                    name: 'Calibri',
                                    color: { argb: '000000' },
                                    size: 7
                                }
                            }
                    } else {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'left',
                            wrapText: true
                        }
                    }
                }
                if (rowNum > 1) {
                    // Aplicar un borde a la celda
                    Cell.border = {
                        top: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                    };
                }

            });
        }); // **Fin Hoja Equipos:**

        // **Hoja Mano de Obra:**
        // Ocultar la columna A
        sheetManObras.getColumn('A').hidden = true;
        // Titulo de Cabecera
        sheetManObras.mergeCells('B1', 'F1');
        titleRow = sheetManObras.getCell('B1');
        titleRow.value = 'MANO DE OBRA';
        titleRow.style = titleStyle;
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
        //Fila en blanco 
        sheetManObras.addRow([]);

        // Columnas de Materiales
        let headersManoObra: string[] = ['', 'Referencia', 'Descripción', 'Jornal Bs.', 'Bono Bs.', 'Agrupación'];
        //Agregar columnas a la hoja materiales
        headerRow = sheetManObras.addRow(headersManoObra);
        headerRow.eachCell((cell, number) => {
            cell.font = fontHeader;
        });
        // Ajustar el ancho de la columnas a una cantidad de caracteres.
        sheetManObras.getColumn('B').width = 8.00;
        sheetManObras.getColumn('C').width = 43.00;
        sheetManObras.getColumn('D').width = 13.00;
        sheetManObras.getColumn('E').width = 8.00;
        sheetManObras.getColumn('F').width = 28.00;

        //Agregar data a la hoja mano de obra
        excelData.dataManoObras.forEach((d: any) => {
            let dataManoObra = sheetManObras.addRow(Object.values(d));
            dataManoObra.font = fontData;
        });
        // set style for each cell
        sheetManObras.eachRow(function (Row, rowNum) {
            if (rowNum > 1) { Row.height = 20; }
            Row.eachCell(function (Cell, cellNum) {
                if (rowNum == 2 || rowNum == 3) {
                    Cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center'
                    }
                } else {
                    if (cellNum == 2) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center'
                        }
                    } else if (cellNum == 4 || cellNum == 5) {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'right'
                        },
                            Cell.style = {
                                numFmt: '#,##0.00',
                                font: {
                                    name: 'Calibri',
                                    color: { argb: '000000' },
                                    size: 7
                                }
                            }
                    } else {
                        Cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'left',
                            wrapText: true
                        }
                    }
                }
                if (rowNum > 1) {
                    // Aplicar un borde a la celda
                    Cell.border = {
                        top: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        left: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        bottom: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                        right: {
                            style: 'thin',
                            color: {
                                argb: 'FF000000',
                            },
                        },
                    };
                }

            });
        }); // **Fin Hoja Mano de Obra:**
        // **Hojas de Partidas Presupuesto:**
        let dataPartidasCapitulos = [];
        for (let index = 0; index < excelData.dataPartidas.length; index++) {
            const partida = excelData.dataPartidas[index];
            const sheetPartida: Worksheet = workbook.addWorksheet('Partida '.concat(String(index + 1)));
        // Ocultar la columna A
            sheetPartida.getColumn('A').hidden = true;
            // Titulo de Cabecera
            sheetPartida.mergeCells('B1', 'H1');
            titleRow = sheetPartida.getCell('B1');
            titleRow.value = 'ANALISIS DE PRECIO UNITARIO';
            titleRow.style = titleStyle;
            titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
            //Fila en blanco 
            sheetPartida.addRow([]);
            sheetPartida.mergeCells('B3', 'H3');
            titleRow = sheetPartida.getCell('B3');
            titleRow.value = 'Obra: '.concat(excelData.nombre);
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } };
            sheetPartida.mergeCells('B4', 'H4');
            titleRow = sheetPartida.getCell('B4');
            titleRow.value = 'Contratante: '.concat(excelData.contratante);
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } };
            titleRow = sheetPartida.getCell('E5');
            titleRow.value = 'Part. No.: ';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'center' } };
            let nroPartidaRow = sheetPartida.getCell('F5');
            nroPartidaRow.value = (index + 1);
            nroPartidaRow.style = { font: fontData, alignment: { vertical: 'middle', horizontal: 'center' } };
            titleRow = sheetPartida.getCell('G5');
            titleRow.value = 'Fecha:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'center' } };
            titleRow = sheetPartida.getCell('H5');
            titleRow.value = partida.updateDate;
            titleRow.style = { font: fontData, numFmt: 'dd/mm/yyyy', alignment: { vertical: 'middle', horizontal: 'center' } };
            titleRow = sheetPartida.getCell('A6');
            titleRow.value = partida.reference;
            titleRow = sheetPartida.getCell('B6');
            titleRow.value = 'Descripción:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'top', horizontal: 'center' } };
            sheetPartida.mergeCells('C6', 'H7');
            let partidaDescRow = sheetPartida.getCell('C6');
            partidaDescRow.value = partida.description;
            partidaDescRow.style = { font: fontData, alignment: { vertical: 'top', horizontal: 'left', wrapText: true } };
            titleRow = sheetPartida.getCell('G8');
            titleRow.value = 'Rendimiento:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'right' } };
            let rendimientoRow = sheetPartida.getCell('H8');
            rendimientoRow.value = partida.lowPerformance;
            rendimientoRow.style = { font: fontData, numFmt: '#,##0.000000', alignment: { vertical: 'middle', horizontal: 'center' } };
            titleRow = sheetPartida.getCell('B9');
            titleRow.value = 'Código:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'right' } };
            let partidaCodeRow = sheetPartida.getCell('C9');
            partidaCodeRow.value = partida.code;
            partidaCodeRow.style = { font: fontData, alignment: { vertical: 'middle', horizontal: 'left' } };
            titleRow = sheetPartida.getCell('E9');
            titleRow.value = 'Unidad:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'right' } };
            let partidaUnidadRow = sheetPartida.getCell('F9');
            partidaUnidadRow.value = partida.unit;
            partidaUnidadRow.style = { font: fontData, alignment: { vertical: 'middle', horizontal: 'center' } };
            titleRow = sheetPartida.getCell('G9');
            titleRow.value = 'Cantidad:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'middle', horizontal: 'right' } };
            let partidaCantidadRow = sheetPartida.getCell('H9');
            partidaCantidadRow.value = partida.quantity;
            partidaCantidadRow.style = { font: fontData, numFmt: '#,##0.00', alignment: { vertical: 'middle', horizontal: 'center' } };
            //Fila en blanco
            sheetPartida.addRow([]);

            //TABLA MATERIALES PARTIDAS
            //Fila en blanco 
            sheetPartida.addRow([]);
            titleRow = sheetPartida.getCell('B'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'MATERIALES';
            titleRow.style = { font: fontDataTitle, alignment: { vertical: 'middle', horizontal: 'left' } };
            // Columnas de Materiales
            let headersMaterialesPresupuesto: string[] = ['', 'No.', 'Descripción', 'Und.', 'Cant.', 'Desp.', 'Precio Bs.', 'Total Bs.'];
            //Agregar columnas a la hoja materiales
            headerRow = sheetPartida.addRow(headersMaterialesPresupuesto);
            headerRow.eachCell((cell, number) => {
                if (number > 1) {
                    cell.font = fontHeader;
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } }
                }
            });
            // Ajustar el ancho de la columnas a una cantidad de caracteres.
            sheetPartida.getColumn('B').width = 9.00;
            sheetPartida.getColumn('C').width = 30.00;
            sheetPartida.getColumn('D').width = 6.00;
            sheetPartida.getColumn('E').width = 8.00;
            sheetPartida.getColumn('F').width = 7.00;
            sheetPartida.getColumn('G').width = 11.00;
            sheetPartida.getColumn('H').width = 12.00;

            //Agregar data a la tabla materiales
            let position = 0;
            if (partida.materialDetailList.length > 0) {
                partida.materialDetailList.forEach((dataMaterialPartidaRow: any) => {
                    excelData.dataMateriales.forEach((dataMaterialPresupuestoRow: any) => {
                        if (dataMaterialPartidaRow['referenceMaterial'] == dataMaterialPresupuestoRow['materialCode']) {
                            let newMaterialPartidaRow = {
                                referenceMaterial: dataMaterialPartidaRow['referenceMaterial'],
                                materialPosition: position += 1,
                                materialDescription: dataMaterialPartidaRow['materialDescription'],
                                materialUnit: dataMaterialPartidaRow['materialUnit'],
                                materialQuantity: dataMaterialPartidaRow['materialQuantity'],
                                wasteMaterial: dataMaterialPartidaRow['wasteMaterial'],
                                priceMaterial: dataMaterialPartidaRow['priceMaterial'],
                                materialTotalPrice: dataMaterialPartidaRow['materialTotalPrice'],
                            }
                            let dataMatePartidas = sheetPartida.addRow(Object.values(newMaterialPartidaRow));
                            dataMatePartidas.font = fontData;
                            sheetMateriales.eachRow((row, rowNumber) => {
                                if (rowNumber < 4) return;
                                let sourceId = row.getCell('B').value;
                                if (sourceId == dataMaterialPartidaRow['referenceMaterial']) {
                                    let sourceDescrip = row.getCell('C');
                                    let sourceUnit = row.getCell('D');
                                    let sourcePrice = row.getCell('E');
                                    let sourceDesp = row.getCell('F');
                                    let sourceCant = dataMatePartidas.getCell('E');
                                    let price = dataMatePartidas.getCell('G');
                                    let desp = dataMatePartidas.getCell('F');
                                    dataMatePartidas.eachCell((cell, cellNum) => {
                                        if (cellNum == 1) {
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 2) {
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 3) {
                                            cell.value = { formula: `=${sourceDescrip.worksheet.name}!${sourceDescrip.address}` };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                                        }
                                        if (cellNum == 4) {
                                            cell.value = { formula: `=${sourceUnit.worksheet.name}!${sourceUnit.address}` };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 5) {
                                            cell.style = { font: fontData, numFmt: '#,##0.0000' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 6) {
                                            cell.value = { formula: `=${sourceDesp.worksheet.name}!${sourceDesp.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 7) {
                                            cell.value = { formula: `${sourcePrice.worksheet.name}!${sourcePrice.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 8) {
                                            cell.value = { formula: `ROUND(ROUND(${price.address}*${sourceCant.address},4)*(1+(${desp.address}/100)),2)` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
            } else {
                let newMaterialPartidaRow = {
                    referenceMaterial: '',
                    materialPosition: '',
                    materialDescription: '',
                    materialUnit: '',
                    materialQuantity: '',
                    wasteMaterial: '',
                    priceMaterial: '',
                    materialTotalPrice: '',
                }
                sheetPartida.addRow(Object.values(newMaterialPartidaRow)).eachCell((cell, cellNum) => {
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                });
            }
            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Total Materiales Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let totalMaterialsRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            totalMaterialsRow.value = { formula: `SUM(H13:H${sheetPartida.lastRow?.number! - 1})` };
            totalMaterialsRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            //Fila en blanco 
            sheetPartida.addRow([]);

            //TABLA EQUIPOS PARTIDAS
            if (partida.materialDetailList.length > 0) { sheetPartida.addRow([]); }
            titleRow = sheetPartida.getCell('B'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'EQUIPOS';
            titleRow.style = { font: fontDataTitle, alignment: { vertical: 'middle', horizontal: 'left' } };
            // Columnas de Equipos
            let headersEquiposPartida: string[] = ['', 'No.', 'Descripción', '', 'Cant.', 'Cop/Dep', 'Precio Bs.', 'Total Bs.'];
            //Agregar columnas a la hoja
            let headerEquipmentRow = sheetPartida.addRow(headersEquiposPartida);
            sheetPartida.mergeCells('C'.concat(String(sheetPartida.lastRow?.number!)), 'D'.concat(String(sheetPartida.lastRow?.number!)));
            headerEquipmentRow.eachCell((cell, number) => {
                if (number > 1) {
                    cell.font = fontHeader;
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } }
                }
            });

            //Agregar data a la tabla equipos
            position = 0;
            if (partida.equipmentDetailList.length > 0) {
                partida.equipmentDetailList.forEach((dataEquipoPartidaRow: any) => {
                    excelData.dataEquipos.forEach((dataEquipoPresupuestoRow: any) => {
                        if (dataEquipoPartidaRow['equipmentReference'] == dataEquipoPresupuestoRow['reference']) {
                            let newEquipoPartidaRow = {
                                equipmentReference: dataEquipoPartidaRow['equipmentReference'],
                                equipmentPosition: position += 1,
                                equipmentDescription: dataEquipoPartidaRow['equipmentDescription'],
                                '': '',
                                quantityEquipment: dataEquipoPartidaRow['quantityEquipment'],
                                depreciationEquipment: dataEquipoPartidaRow['depreciationEquipment'],
                                priceEquipment: dataEquipoPartidaRow['priceEquipment'],
                                equipmentTotalPrice: dataEquipoPartidaRow['equipmentTotalPrice'],
                            }
                            let dataEquipoPartidas = sheetPartida.addRow(Object.values(newEquipoPartidaRow));
                            dataEquipoPartidas.font = fontData;
                            sheetPartida.mergeCells('C'.concat(String(sheetPartida.lastRow?.number!)), 'D'.concat(String(sheetPartida.lastRow?.number!)));
                            sheetEquipos.eachRow((row, rowNumber) => {
                                if (rowNumber < 4) return;
                                let sourceId = row.getCell('B').value;
                                if (sourceId == dataEquipoPartidaRow['equipmentReference']) {
                                    let sourceDescrip = row.getCell('C');
                                    let sourcePrice = row.getCell('D');
                                    let sourceDesp = row.getCell('E');
                                    let cant = dataEquipoPartidas.getCell('E');
                                    let price = dataEquipoPartidas.getCell('G');
                                    let desp = dataEquipoPartidas.getCell('F');
                                    dataEquipoPartidas.eachCell((cell, cellNum) => {
                                        if (cellNum == 1) {
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 2) {
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 3) {
                                            cell.value = { formula: `=${sourceDescrip.worksheet.name}!${sourceDescrip.address}` };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                                        }
                                        if (cellNum == 5) {
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 6) {
                                            cell.value = { formula: `=${sourceDesp.worksheet.name}!${sourceDesp.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.000000' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 7) {
                                            cell.value = { formula: `${sourcePrice.worksheet.name}!${sourcePrice.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 8) {
                                            cell.value = { formula: `ROUND(ROUND(${desp.address}*${price.address},6)*(${cant.address}),2)` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
            } else {
                let newEquipoPartidaRow = {
                    equipmentReference: '',
                    equipmentPosition: '',
                    equipmentDescription: '',
                    '': '',
                    quantityEquipment: '',
                    depreciationEquipment: '',
                    priceEquipment: '',
                    equipmentTotalPrice: '',
                }
                sheetPartida.addRow(Object.values(newEquipoPartidaRow)).eachCell((cell, cellNum) => {
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                });
            }
            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Total Equipos Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            titleRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = { formula: `SUM(H${headerEquipmentRow.number + 1}:H${sheetPartida.lastRow?.number! - 1})` };
            titleRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            sheetPartida.mergeCells('E'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Costo Unitarios Equipos Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let costoUnitarioEquipoRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            costoUnitarioEquipoRow.value = { formula: `ROUND(H${sheetPartida.lastRow?.number! - 1}/${rendimientoRow.address},2)` };
            costoUnitarioEquipoRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            //Fila en blanco 
            sheetPartida.addRow([]);

            //TABLA MANO OBRAS PARTIDAS
            if (partida.equipmentDetailList.length > 0) { sheetPartida.addRow([]).height = 5; }
            titleRow = sheetPartida.getCell('B'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'MANO DE OBRA';
            titleRow.style = { font: fontDataTitle, alignment: { vertical: 'middle', horizontal: 'left' } };
            // Columnas de Mano de Obra
            let headersObrasPartida: string[] = ['', 'No.', 'Descripción', 'Cant.', 'Jornal Bs.', 'Bono Bs.', 'Total Jornal Bs.', 'Total Bono Bs.'];
            //Agregar columnas a la hoja
            let headerLaborRow = sheetPartida.addRow(headersObrasPartida);
            headerLaborRow.eachCell((cell, number) => {
                if (number > 1) {
                    cell.font = fontHeader;
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } }
                }
            });

            //Agregar data a la tabla mano obras
            position = 0;
            if (partida.laborDetailList.length > 0) {
                partida.laborDetailList.forEach((dataManoObraPartidaRow: any) => {
                    excelData.dataManoObras.forEach((dataManoObraPresupuestoRow: any) => {
                        if (dataManoObraPartidaRow['laborReference'] == dataManoObraPresupuestoRow['reference']) {
                            let newManoObraPartidaRow = {
                                laborReference: dataManoObraPartidaRow['laborReference'],
                                laborPosition: position += 1,
                                laborDescription: dataManoObraPartidaRow['laborDescription'],
                                quantityLabor: dataManoObraPartidaRow['quantityLabor'],
                                jornalLabor: dataManoObraPartidaRow['jornalLabor'],
                                bonoLabor: dataManoObraPartidaRow['priceLabor'],
                                laborTotalJornal: dataManoObraPartidaRow['laborTotalJornal'],
                                laborTotalBonus: dataManoObraPartidaRow['laborTotalBonus']
                            }
                            let dataManoObraPartidas = sheetPartida.addRow(Object.values(newManoObraPartidaRow));
                            dataManoObraPartidas.font = fontData;
                            sheetManObras.eachRow((row, rowNumber) => {
                                if (rowNumber < 4) return;
                                let sourceId = row.getCell('B').value;
                                if (sourceId == dataManoObraPartidaRow['laborReference']) {
                                    let sourceDescrip = row.getCell('C');
                                    let sourceJornal = row.getCell('D');
                                    let sourceBono = row.getCell('E');
                                    let cant = dataManoObraPartidas.getCell('D');
                                    let jornal = dataManoObraPartidas.getCell('E');
                                    let bono = dataManoObraPartidas.getCell('F');
                                    dataManoObraPartidas.eachCell((cell, cellNum) => {
                                        if (cellNum == 1) {
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 2) {
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                        }
                                        if (cellNum == 3) {
                                            cell.value = { formula: `='${sourceDescrip.worksheet.name}'!${sourceDescrip.address}` };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                                        }
                                        if (cellNum == 4) {
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 5) {
                                            cell.value = { formula: `='${sourceJornal.worksheet.name}'!${sourceJornal.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 6) {
                                            cell.value = { formula: `='${sourceBono.worksheet.name}'!${sourceBono.address}` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 7) {
                                            cell.value = { formula: `ROUND((${cant.address}*${jornal.address}),2)` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                        if (cellNum == 8) {
                                            cell.value = { formula: `ROUND((${cant.address}*${bono.address}),2)` };
                                            cell.style = { font: fontData, numFmt: '#,##0.00' };
                                            cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                            cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
            } else {
                let newManoObraPartidaRow = {
                    laborReference: '',
                    laborPosition: '',
                    laborDescription: '',
                    quantityLabor: '',
                    jornalLabor: '',
                    bonoLabor: '',
                    laborTotalJornal: '',
                    laborTotalBonus: ''
                }
                sheetPartida.addRow(Object.values(newManoObraPartidaRow)).eachCell((cell, cellNum) => {
                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                });
            }
            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'F'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'SubTotal Mano de Obra Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let subTotalJornalRow = sheetPartida.getCell('G'.concat(String(sheetPartida.lastRow?.number)));
            subTotalJornalRow.value = { formula: `SUM(G${headerLaborRow.number + 1}:G${sheetPartida.lastRow?.number! - 1})` };
            subTotalJornalRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            let subTotalBonoRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            subTotalBonoRow.value = { formula: `SUM(H${headerLaborRow.number + 1}:H${sheetPartida.lastRow?.number! - 1})` };
            subTotalBonoRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'F'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Prestaciones Sociales Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let numPrestacionesRow = sheetPartida.getCell('C'.concat(String(sheetPartida.lastRow?.number)));
            numPrestacionesRow.value = partida.porcPrestacionesManoDeObra;
            numPrestacionesRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };

            let prestacionesJornalRow = sheetPartida.getCell('G'.concat(String(sheetPartida.lastRow?.number)));
            prestacionesJornalRow.value = { formula: `ROUND((${numPrestacionesRow.address}/100)*${subTotalJornalRow.address},2)` };
            prestacionesJornalRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            let prestacionesBonoRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            prestacionesBonoRow.value = 0;
            prestacionesBonoRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Total General Mano de Obra Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let totalGralObraRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            totalGralObraRow.value = { formula: `${prestacionesJornalRow.address}+${prestacionesBonoRow.address}+${subTotalJornalRow.address}+${subTotalBonoRow.address}` };
            totalGralObraRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Costo Unitario de Mano de Obra Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let costoUnitarioObrasRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            costoUnitarioObrasRow.value = { formula: `ROUND(${totalGralObraRow.address}/${rendimientoRow.address},2)` };
            costoUnitarioObrasRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            //Fila en blanco 
            sheetPartida.addRow([]).height = 5;

            sheetPartida.mergeCells('E'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'COSTO DIRECTO SUBTOTAL A Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let costoDirecSubTotalA = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            costoDirecSubTotalA.value = { formula: `ROUND(${totalMaterialsRow.address}+${costoUnitarioEquipoRow.address}+${costoUnitarioObrasRow.address},2)` };
            costoDirecSubTotalA.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Administración y Gastos Generales Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let adminGastosGralesRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            let numAdminGastosGralesRow = sheetPartida.getCell('C'.concat(String(sheetPartida.lastRow?.number)));
            numAdminGastosGralesRow.value = partida.porcGastosAdministrativos;
            numAdminGastosGralesRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };
            adminGastosGralesRow.value = { formula: `ROUND((${costoDirecSubTotalA.address}*${numAdminGastosGralesRow.address})/100,2)` };
            adminGastosGralesRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'SUBTOTAL B Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let subTotalB = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            subTotalB.value = { formula: `${costoDirecSubTotalA.address}+${adminGastosGralesRow.address}` };
            subTotalB.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Imprevisto Utilidad Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let imprevUtilidadRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            let numImprevUtilidadRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            numImprevUtilidadRow.value = partida.porcUtilidadesImprevisto;
            numImprevUtilidadRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };
            imprevUtilidadRow.value = { formula: `ROUND((${subTotalB.address}*${numImprevUtilidadRow.address})/100,2)` };
            imprevUtilidadRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'SUBTOTAL C Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let subTotalC = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            subTotalC.value = { formula: `${subTotalB.address}+${imprevUtilidadRow.address}` };
            subTotalC.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Financiamiento Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let financiamientoRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            let numFinanciamientoRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            numFinanciamientoRow.value = partida.porcFinanciamiento;
            numFinanciamientoRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };
            financiamientoRow.value = { formula: `ROUND((${subTotalC.address}*${numFinanciamientoRow.address})/100,2)` };
            financiamientoRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'PRECIO UNITARIO SIN IMPUESTO Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let precioUnitarioSinImpuRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            precioUnitarioSinImpuRow.value = { formula: `${subTotalC.address}+${financiamientoRow.address}` };
            precioUnitarioSinImpuRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Impuesto (I.V.A.) Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let impuestoIvaRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            let numImpuestoIvaRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            numImpuestoIvaRow.value = partida.porcImpuestoIva;
            numImpuestoIvaRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };
            if (excelData.aplicaIva == Constanst.APLICAR_IVA_APU) {
                impuestoIvaRow.value = { formula: `ROUND((${precioUnitarioSinImpuRow.address}*${numImpuestoIvaRow.address})/100,2)` };
            } else {
                impuestoIvaRow.value = { formula: `ROUND((${precioUnitarioSinImpuRow.address}*0)/100,2)` };
            }
            impuestoIvaRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            sheetPartida.mergeCells('F'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('F'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'Otros Impuestos Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let otrosImpuestoIvaRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            let numOtrosImpuestoIvaRow = sheetPartida.getCell('E'.concat(String(sheetPartida.lastRow?.number)));
            numOtrosImpuestoIvaRow.value = partida.porcOtrosImpuestos;
            numOtrosImpuestoIvaRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' } };
            if (excelData.aplicaIva == Constanst.APLICAR_IVA_APU) {
                otrosImpuestoIvaRow.value = { formula: `ROUND((${precioUnitarioSinImpuRow.address}*${numOtrosImpuestoIvaRow.address})/100,2)` };
            } else {
                otrosImpuestoIvaRow.value = { formula: `ROUND((${precioUnitarioSinImpuRow.address}*0)/100,2)` };
            }
            otrosImpuestoIvaRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
            //Fila en blanco 
            sheetPartida.addRow([]).height = 5;

            sheetPartida.mergeCells('D'.concat(String(sheetPartida.lastRow?.number! + 1)), 'G'.concat(String(sheetPartida.lastRow?.number! + 1)));
            titleRow = sheetPartida.getCell('D'.concat(String(sheetPartida.lastRow?.number)));
            titleRow.value = 'PRECIO UNITARIO Bs.:';
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            let precioUnitarioRow = sheetPartida.getCell('H'.concat(String(sheetPartida.lastRow?.number)));
            precioUnitarioRow.value = { formula: `${precioUnitarioSinImpuRow.address}+${impuestoIvaRow.address}+${otrosImpuestoIvaRow.address}` };
            precioUnitarioRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

            // set height for each cell
            sheetPartida.eachRow(function (Row, rowNum) { if (rowNum > 12) { Row.height = 20; } });

            let newPartidaPresupuesto = {
                partidaReference: partida.reference,
                partidaPosition: (index + 1),
                partidaCode: partida.code,
                partidaDescription: partida.description,
                partidaUnit: partida.unit,
                partidaQuantity: partida.quantity,
                partidaPrice: 0,
                partidaTotal: 0,
                partidaCapitulo: partida.desCapitulo,
                cellPrecioUnitario: precioUnitarioRow
            }
            dataPartidasCapitulos.push(newPartidaPresupuesto);

        }// **Fin Hojas de Partidas Presupuesto:**

        //** Hoja Presupuesto **
        let sheetPresupuesto: Worksheet = workbook.addWorksheet('PRESUPUESTO');
        // Ocultar la columna A
        sheetPresupuesto.getColumn('A').hidden = true;
        // Titulo de Cabecera
        sheetPresupuesto.mergeCells('B1', 'H1');
        let titleeRow = sheetPresupuesto.getCell('B1');
        titleeRow.value = excelData.compania;
        titleeRow.style = { font: { name: 'Arial', color: { argb: '000000' }, size: 16, bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } };
        sheetPresupuesto.getRow(1).height = 22;

        sheetPresupuesto.mergeCells('B2', 'H2');
        let titleObraRow = sheetPresupuesto.getCell('B2');
        titleObraRow.value = 'Obra: '.concat(excelData.nombre);
        titleObraRow.style = { font: { name: 'Calibri', color: { argb: '000000' }, size: 11, bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } };
        sheetPresupuesto.getRow(2).height = 32;

        sheetPresupuesto.mergeCells('B3', 'H3');
        titleRow = sheetPresupuesto.getCell('B3');
        titleRow.value = 'Ubicación: '.concat(excelData.ubicacion).concat('\n').concat('Contratante: '.concat(excelData.contratante));
        titleRow.style = { font: { name: 'Calibri', color: { argb: '000000' }, size: 11, bold: true }, alignment: { vertical: 'middle', horizontal: 'left', wrapText: true } };
        sheetPresupuesto.getRow(3).height = 32;

        sheetPresupuesto.mergeCells('B4', 'H4');
        titleRow = sheetPresupuesto.getCell('B4');
        titleRow.value = 'PRESUPUESTO';
        titleRow.style = titleStyle;
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };
        //Filas en blanco 
        sheetPresupuesto.addRow([]);
        sheetPresupuesto.addRow([]);

        // Columnas de Mano de Obra
        let headersPresupuesto: string[] = ['', 'Part No.', 'Código', 'Descripción', 'Unidad', 'Cantidad', 'Precio Unitario', 'Total'];
        //Agregar columnas a la hoja
        let headerPresupuesto = sheetPresupuesto.addRow(headersPresupuesto);
        headerPresupuesto.eachCell((cell, number) => {
            if (number > 1) {
                cell.font = fontHeader;
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } }
            }
        });
        // Ajustar el ancho de la columnas.
        sheetPresupuesto.getColumn('B').width = 8.00;
        sheetPresupuesto.getColumn('C').width = 9.00;
        sheetPresupuesto.getColumn('D').width = 30.00;
        sheetPresupuesto.getColumn('E').width = 8.00;
        sheetPresupuesto.getColumn('F').width = 9.00;
        sheetPresupuesto.getColumn('G').width = 11.00;
        sheetPresupuesto.getColumn('H').width = 12.00;

        //Agregar data a la hoja presupuesto
        if (!excelData.formatoEscritorio) {
            for (let j = 0; j < excelData.capitulosPartida.length; j++) {
                let capitulo = excelData.capitulosPartida[j];
                sheetPresupuesto.mergeCells('B'.concat(String(sheetPresupuesto.lastRow?.number! + 1)), 'H'.concat(String(sheetPresupuesto.lastRow?.number! + 1)));
                titleRow = sheetPresupuesto.getCell('B'.concat(String(sheetPresupuesto.lastRow?.number)));
                titleRow.value = capitulo;
                titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'left' } };
                for (let i = 0; i < dataPartidasCapitulos.length; i++) {
                    let partida: any = dataPartidasCapitulos[i];

                    if (partida.partidaCapitulo == capitulo) {
                        let newPartidaPresupuestoRow = {
                            '': partida.partidaReference,
                            partidaPosition: partida.partidaPosition,
                            partidaCode: partida.partidaCode,
                            partidaDescription: partida.partidaDescription,
                            partidaUnit: partida.partidaUnit,
                            partidaQuantity: partida.partidaQuantity,
                            partidaPrice: partida.partidaPrice,
                            partidaTotal: 0,
                        }
                        let dataPartPrep = sheetPresupuesto.addRow(Object.values(newPartidaPresupuestoRow));
                        dataPartPrep.font = fontData;
                        dataPartPrep.height = 60;
                        let sheetPartPrep: Worksheet = workbook.getWorksheet('Partida '.concat(String(partida.partidaPosition)))!;
                        sheetPartPrep.eachRow((row, rowNumber) => {
                            let cant = dataPartPrep.getCell('F');
                            let precio = dataPartPrep.getCell('G');
                            let precioUnitario = partida.cellPrecioUnitario;
                            dataPartPrep.eachCell((cell, cellNum) => {
                                if (cellNum == 1) {
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                }
                                if (cellNum == 2) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!F5` };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                }
                                if (cellNum == 3) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!C9` };
                                    cell.style = { font: fontData };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                }
                                if (cellNum == 4) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!C6` };
                                    cell.style = { font: fontData };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'justify', wrapText: true };
                                }
                                if (cellNum == 5) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!F9` };
                                    cell.style = { font: fontData };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                                }
                                if (cellNum == 6) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!H9` };
                                    cell.style = { font: fontData, numFmt: '#,##0.00' };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                }
                                if (cellNum == 7) {
                                    cell.value = { formula: `='${sheetPartPrep.name}'!${precioUnitario.address}` };
                                    cell.style = { font: fontData, numFmt: '#,##0.00' };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                }
                                if (cellNum == 8) {
                                    cell.value = { formula: `ROUND(${cant.address}*${precio.address},2)` };
                                    cell.style = { font: fontData, numFmt: '#,##0.00' };
                                    cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                    cell.alignment = { vertical: 'middle', horizontal: 'right' };
                                }
                            });
                        });
                    }
                }
            }
        } else {
            for (let j = 0; j < excelData.capitulosPartida.length; j++) {
                for (let i = 0; i < dataPartidasCapitulos.length; i++) {
                    let partida: any = dataPartidasCapitulos[i];
                    let newPartidaPresupuestoRow = {
                        '': partida.partidaReference,
                        partidaPosition: partida.partidaPosition,
                        partidaCode: partida.partidaCode,
                        partidaDescription: partida.partidaDescription,
                        partidaUnit: partida.partidaUnit,
                        partidaQuantity: partida.partidaQuantity,
                        partidaPrice: partida.partidaPrice,
                        partidaTotal: 0,
                    }
                    let dataPartPrep = sheetPresupuesto.addRow(Object.values(newPartidaPresupuestoRow));
                    dataPartPrep.font = fontData;
                    dataPartPrep.height = 60;
                    let sheetPartPrep: Worksheet = workbook.getWorksheet('Partida '.concat(String(partida.partidaPosition)))!;
                    sheetPartPrep.eachRow((row, rowNumber) => {
                        let cant = dataPartPrep.getCell('F');
                        let precio = dataPartPrep.getCell('G');
                        let precioUnitario = partida.cellPrecioUnitario;
                        dataPartPrep.eachCell((cell, cellNum) => {
                            if (cellNum == 1) {
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                            }
                            if (cellNum == 2) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!F5` };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                            }
                            if (cellNum == 3) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!C9` };
                                cell.style = { font: fontData };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                            }
                            if (cellNum == 4) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!C6` };
                                cell.style = { font: fontData };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'justify', wrapText: true };
                            }
                            if (cellNum == 5) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!F9` };
                                cell.style = { font: fontData };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                            }
                            if (cellNum == 6) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!H9` };
                                cell.style = { font: fontData, numFmt: '#,##0.00' };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                            }
                            if (cellNum == 7) {
                                cell.value = { formula: `='${sheetPartPrep.name}'!${precioUnitario.address}` };
                                cell.style = { font: fontData, numFmt: '#,##0.00' };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                            }
                            if (cellNum == 8) {
                                cell.value = { formula: `ROUND(${cant.address}*${precio.address},2)` };
                                cell.style = { font: fontData, numFmt: '#,##0.00' };
                                cell.border = { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } };
                                cell.alignment = { vertical: 'middle', horizontal: 'right' };
                            }
                        });
                    });
                }
            }
        }

        sheetPresupuesto.mergeCells('F'.concat(String(sheetPresupuesto.lastRow?.number! + 1)), 'G'.concat(String(sheetPresupuesto.lastRow?.number! + 1)));
        titleRow = sheetPresupuesto.getCell('F'.concat(String(sheetPresupuesto.lastRow?.number)));
        titleRow.value = 'SubtotalBs.:';
        titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
        let subTotalRow = sheetPresupuesto.getCell('H'.concat(String(sheetPresupuesto.lastRow?.number)));
        subTotalRow.value = { formula: `SUM(H${headerPresupuesto.number + 1}:H${sheetPresupuesto.lastRow?.number! - 1})` };
        subTotalRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

        sheetPresupuesto.mergeCells('F'.concat(String(sheetPresupuesto.lastRow?.number! + 1)), 'G'.concat(String(sheetPresupuesto.lastRow?.number! + 1)));
        titleRow = sheetPresupuesto.getCell('F'.concat(String(sheetPresupuesto.lastRow?.number)));
        titleRow.value = `IVA ${excelData.porcIva} % Bs.:`;
        titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
        let totalIvaRow = sheetPresupuesto.getCell('H'.concat(String(sheetPresupuesto.lastRow?.number)));
        if (excelData.aplicaIva == Constanst.APLICAR_IVA_PRESUPUESTO) {
            totalIvaRow.value = { formula: `ROUND((${subTotalRow.address}*${excelData.porcIva}/100),2)` };
        } else {
            totalIvaRow.value = { formula: `ROUND((${subTotalRow.address}*0/100),2)` };
        }
        totalIvaRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

        let totalOtrosImpRow: Cell;
        if (!excelData.formatoEscritorio) {
            sheetPresupuesto.mergeCells('F'.concat(String(sheetPresupuesto.lastRow?.number! + 1)), 'G'.concat(String(sheetPresupuesto.lastRow?.number! + 1)));
            titleRow = sheetPresupuesto.getCell('F'.concat(String(sheetPresupuesto.lastRow?.number)));
            titleRow.value = `Otros Impuestos ${excelData.porcOtrosImp} % Bs.:`;
            titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
            totalOtrosImpRow = sheetPresupuesto.getCell('H'.concat(String(sheetPresupuesto.lastRow?.number)));
            if (excelData.aplicaIva == Constanst.APLICAR_IVA_PRESUPUESTO) {
                totalOtrosImpRow.value = { formula: `ROUND((${subTotalRow.address}*${excelData.porcOtrosImp}/100),2)` };
            } else {
                totalOtrosImpRow.value = { formula: `ROUND((${subTotalRow.address}*0/100),2)` };
            }
            totalOtrosImpRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };
        }

        sheetPresupuesto.mergeCells('F'.concat(String(sheetPresupuesto.lastRow?.number! + 1)), 'G'.concat(String(sheetPresupuesto.lastRow?.number! + 1)));
        titleRow = sheetPresupuesto.getCell('F'.concat(String(sheetPresupuesto.lastRow?.number)));
        titleRow.value = 'Total Presupuesto Bs.:';
        titleRow.style = { font: fontHeader, alignment: { vertical: 'bottom', horizontal: 'right' } };
        titleRow = sheetPresupuesto.getCell('H'.concat(String(sheetPresupuesto.lastRow?.number)));
        if (!excelData.formatoEscritorio) {
            titleRow.value = { formula: `ROUND((${subTotalRow.address} + ${totalIvaRow.address} + ${totalOtrosImpRow!.address}),2)` };
        } else {
            titleRow.value = { formula: `ROUND((${subTotalRow.address} + ${totalIvaRow.address}),2)` };
        }
        titleRow.style = { font: fontHeader, numFmt: '#,##0.00', alignment: { vertical: 'bottom', horizontal: 'right' }, border: { top: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }, bottom: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } } } };

        //Generar y guardar Excel
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, `${workbook.title}.xlsx`);
        });
        this.helperClassService.notifierNewChangeBudget.emit('processedExcel');
    }
}